import React, { useContext, useEffect, useRef, useState } from 'react'
import { 
  Container,
  HeaderDiv, 
  HeaderText, 
  HeaderPlusDiv, 
  HeaderPlusImg,
  StructuresDiv,
  StructureDiv,
  StructureText,
  StructureDotsDiv,
  StructureDotsImg
} from './style'
import plus from '../../../../assets/certificates/AddParameter/blue-plus.svg'
import dots from '../../../../assets/certificates/AddParameter/vertical-three-dots.svg'
import ModalContext from '../../../../contexts/ModalContext'
import ParametersContext from '../../../../contexts/ParametersContext'
import OptionsDropdown from './OptionsDropdown'

const ManageStructures: React.FC = () => {
  const { setModalSection, setModalActive } = useContext(ModalContext)
  const { structures } = useContext(ParametersContext)
  const [ openedDropdown, setOpenedDropdown ] = useState<number>(-1)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const handleModal = () => {
    setModalSection('addParamStructure')
    setModalActive(true)
  }

  const setDropdownIndex = (index: number) => {
    if (dropdownRef.current){
      setOpenedDropdown(-1)
      return
    }
    setOpenedDropdown(index)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setOpenedDropdown(-1)
        }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);}
}, []);

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Estrutura</HeaderText>
        <HeaderPlusDiv onClick={() => handleModal()}>
          <HeaderPlusImg src={plus} alt='Plus icon'/>
        </HeaderPlusDiv>
      </HeaderDiv>
      <StructuresDiv>
        {structures.map((item, index) => (
           <StructureDiv 
            key={index} 
            className={index !== structures.length-1 ? 'notLast' : ''}
          >
            <StructureText>{item.name}</StructureText>
            <StructureDotsDiv onClick={() => setDropdownIndex(index)}>
              <StructureDotsImg src={dots} alt='Vertical three dots'/>
            </StructureDotsDiv>
            {openedDropdown === index && <OptionsDropdown onChange={() => setOpenedDropdown(-1)} ref={dropdownRef} index={index} />}
          </StructureDiv>
        ))}
      </StructuresDiv>
    </Container>
  )
}
export default ManageStructures
